"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCat = getCat;

var _request = _interopRequireDefault(require("@/utils/request"));

function getCat(id) {
  return (0, _request.default)({
    url: "/cat/".concat(id),
    method: 'get'
  });
}